import Vue from 'vue'

//获取cookie、
export function getCookie (name) {
  var arr, reg = new RegExp("(^| )" + name + "=([^;]*)(;|$)");
  if (arr = document.cookie.match(reg))
    return (arr[2]);
  else
    return '';
}

//设置cookie,增加到vue实例方便全局调用
export function setCookie (c_name, value, expiredays) {
  var exdate = new Date();
  exdate.setDate(exdate.getDate() + expiredays);
  document.cookie = c_name + "=" + escape(value) + ((expiredays == null) ? "" : ";expires=" + exdate.toGMTString());
};

//删除cookie
export function delCookie (name) {
  var exp = new Date();
  exp.setTime(exp.getTime() - 1);
  var cval = getCookie(name);
  if (cval != null)
    document.cookie = name + "=" + cval + ";expires=" + exp.toGMTString();
};

/**
 * 过滤HTML标签
 */
export function removeHTMLTag (str) {
  str = str.replace(/<\/?[^>]*>/g, ''); //去除HTML tag
  str = str.replace(/[ | ]*\n/g, '\n'); //去除行尾空白
  //str = str.replace(/\n[\s| | ]*\r/g,'\n'); //去除多余空行
  str = str.replace(/ /ig, '');//去掉
  return str;
}

export function formatMoney (x) {
  var f = parseFloat(x);
  if (isNaN(f)) {
    return;
  }
  f = Math.round(x * 100) / 100;
  return f;
}

//检查手机号是否合法 11位数字即可
export function isValidPhone (str) {
  // var myreg = /^(((13[0-9]{1})|(15[0-9]{1})|(18[0-9]{1})|(17[0-9]{1}))+\d{8})$/;
  var myreg = /^\d{11}$/;
  if (!myreg.test(str)) {
    return false;
  } else {
    return true;
  }
}

//检查姓名:6-20位数字字母下划线
export function isValidName (str) {
  var myreg = /^([\u4e00-\u9fa5]{1,50}|[a-zA-Z\ \s]{1,50})$/;
  if (!myreg.test(str)) {
    return false;
  } else {
    return true;
  }
}

//检查密码： 6-20位字符
export function isValidPassword (str) {
  // var myreg = /^([\u4e00-\u9fa5]{1,20}|[a-zA-Z\ \s]{1,20})$/;
  var myreg = /^(.*?){6,20}$/;
  if (!myreg.test(str)) {
    return false;
  } else {
    return true;
  }
}

//检查登录姓名:6-20位数字字母下划线
export function isValidLoginName (str) {
  // var myreg = /^([\u4e00-\u9fa5]{1,20}|[a-zA-Z\ \s]{1,20})$/;
  var myreg = /^\w{6,20}$/;
  if (!myreg.test(str)) {
    return false;
  } else {
    return true;
  }
}

/**
 *深拷贝
 */
export function deepClone (obj) {
  let _obj = JSON.stringify(obj)
  return JSON.parse(_obj)
}

/**
 * 清除登录信息
 */
export function clearLoginInfo () {
  Vue.cookie.delete('token')
}

/**
 * 针对对象数据进行排序propertyName 要排序的属性名，order 1为正序0为倒序
 */
export function compare (propertyName, order) {
  return function (object1, object2) {
    var value1 = object1[propertyName];
    var value2 = object2[propertyName];
    if (order == 0) {
      if (value2 < value1) {
        return -1;
      }
      else if (value2 > value1) {
        return 1;
      }
      else {
        return 0;
      }
    } if (order == 1) {
      if (value2 > value1) {
        return -1;
      }
      else if (value2 < value1) {
        return 1;
      }
      else {
        return 0;
      }
    }

  }
}

/**
 * 获取当前时间(年月日)
 */
export function getCurrentTime (time) {
  var now = time ? new Date(time) : new Date()
  var year = now.getFullYear()
  var month = now.getMonth() + 1
  var day = now.getDate()
  month = month < 10 ? '0' + month : month
  day = day < 10 ? '0' + day : day
  return year + '-' + month + '-' + day
}

/**
 * 比较时间大小
 */
export function compareDate (date1, date2) {
  console.log(date1)
  console.log(date2)
  var oDate1 = new Date(date1);
  var oDate2 = new Date(date2);
  if (oDate1.getTime() > oDate2.getTime()) {
    return true; //第一个大
  } else {
    return false; //第二个大
  }
}

/**
 * 判断是否是PC端
 */
export function IsPC () {
  let userAgentInfo = navigator.userAgent;
  let Agents = ["Android", "iPhone",
    "SymbianOS", "Windows Phone",
    "iPad", "iPod"];
  let flag = true;
  for (let v = 0; v < Agents.length; v++) {
    if (userAgentInfo.indexOf(Agents[v]) > 0) {
      flag = false;
      break;
    }
  }
  return flag
}

export function Percentage (number1, number2) {
  return (Math.round(number1 / (number2) * 1000) / 10.00 + "%");
}

export function numberLength (number) {
  return number.toString().length
}

export function discountCoupon (number1, number2) {
  return (Math.round((number1 / number2) * 10) / 10.00)
}

export function percentNum (number1, number2) {
  return (Math.round(number1 / (number2) * 1000) / 10.00);
}

export function getBirthdayFromIdCard (idCard) {
  let birthday = "";
  if (idCard != null && idCard !== "") {
    if (idCard.length === 15) {
      birthday = "19" + idCard.substr(6, 6);
    } else if (idCard.length === 18) {
      birthday = idCard.substr(6, 8);
    }

    birthday = birthday.replace(/(.{4})(.{2})/, "$1-$2-");
  }

  return birthday;
}

export function Base64 () {
  // private property
  let _keyStr = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=";

  // public method for encoding
  this.encode = function (input) {
    var output = "";
    var chr1, chr2, chr3, enc1, enc2, enc3, enc4;
    var i = 0;
    input = _utf8_encode(input);
    while (i < input.length) {
      chr1 = input.charCodeAt(i++);
      chr2 = input.charCodeAt(i++);
      chr3 = input.charCodeAt(i++);
      enc1 = chr1 >> 2;
      enc2 = ((chr1 & 3) << 4) | (chr2 >> 4);
      enc3 = ((chr2 & 15) << 2) | (chr3 >> 6);
      enc4 = chr3 & 63;
      if (isNaN(chr2)) {
        enc3 = enc4 = 64;
      } else if (isNaN(chr3)) {
        enc4 = 64;
      }
      output = output +
        _keyStr.charAt(enc1) + _keyStr.charAt(enc2) +
        _keyStr.charAt(enc3) + _keyStr.charAt(enc4);
    }
    return output;
  }

  // public method for decoding
  this.decode = function (input) {
    var output = "";
    var chr1, chr2, chr3;
    var enc1, enc2, enc3, enc4;
    var i = 0;
    input = input.replace(/[^A-Za-z0-9\+\/\=]/g, "");
    while (i < input.length) {
      enc1 = _keyStr.indexOf(input.charAt(i++));
      enc2 = _keyStr.indexOf(input.charAt(i++));
      enc3 = _keyStr.indexOf(input.charAt(i++));
      enc4 = _keyStr.indexOf(input.charAt(i++));
      chr1 = (enc1 << 2) | (enc2 >> 4);
      chr2 = ((enc2 & 15) << 4) | (enc3 >> 2);
      chr3 = ((enc3 & 3) << 6) | enc4;
      output = output + String.fromCharCode(chr1);
      if (enc3 != 64) {
        output = output + String.fromCharCode(chr2);
      }
      if (enc4 != 64) {
        output = output + String.fromCharCode(chr3);
      }
    }
    output = _utf8_decode(output);
    return output;
  }

  // private method for UTF-8 encoding
  let _utf8_encode = function (string) {
    string = string.replace(/\r\n/g, "\n");
    var utftext = "";
    for (var n = 0; n < string.length; n++) {
      var c = string.charCodeAt(n);
      if (c < 128) {
        utftext += String.fromCharCode(c);
      } else if ((c > 127) && (c < 2048)) {
        utftext += String.fromCharCode((c >> 6) | 192);
        utftext += String.fromCharCode((c & 63) | 128);
      } else {
        utftext += String.fromCharCode((c >> 12) | 224);
        utftext += String.fromCharCode(((c >> 6) & 63) | 128);
        utftext += String.fromCharCode((c & 63) | 128);
      }

    }
    return utftext;
  }

  // private method for UTF-8 decoding
  let _utf8_decode = function (utftext) {
    var string = "";
    var i = 0;
    var c = 0;
    var c1 = 0;
    var c2 = 0;
    while (i < utftext.length) {
      c = utftext.charCodeAt(i);
      if (c < 128) {
        string += String.fromCharCode(c);
        i++;
      } else if ((c > 191) && (c < 224)) {
        var c2 = utftext.charCodeAt(i + 1);
        string += String.fromCharCode(((c & 31) << 6) | (c2 & 63));
        i += 2;
      } else {
        var c2 = utftext.charCodeAt(i + 1);
        var c3 = utftext.charCodeAt(i + 2);
        string += String.fromCharCode(((c & 15) << 12) | ((c2 & 63) << 6) | (c3 & 63));
        i += 3;
      }
    }
    return string;
  }
}


// 与当前时间对比映射与当前的关系的文本
Vue.filter('reactTime', time => {
  const today = new Date().getTime()
  const tim = new Date(time.replace(/-/g, '/')).getTime()
  const diff = today - tim
  // 一分钟内
  if (diff <= 60000) { return `刚刚` }
  // 一小时内
  else if (diff <= 3600000) { return `${Math.floor(diff / 60000)}分钟前` }
  // 一天内
  else if (diff <= 3600000 * 24) { return `${Math.floor(diff / (60000 * 60))}小时前` }
  // 七天内
  else if (diff <= 3600000 * 24 * 7) { return `${Math.floor(diff / (60000 * 60 * 24))}天前` } else {
    try {
      return `${time}`.substr(0, 10)
    } catch (e) {
      return `${time}`
    }
  }
})

Vue.filter('reactNumber', (num, def) => {
  return num == 0 || !num ? def || '' : num
})

Vue.filter('fixed', (num, f) => {
  let fax = f || 2
  return Number(isNaN(num) ? 0 : num).toFixed(fax)
})


// WEBPACK FOOTER //
// ./src/util/util.js